import { useContext } from 'react'
import { CartContext, CartContextProps } from 'state'

export const useCart = (): CartContextProps => useContext(CartContext)
